import { keyBy } from 'lodash';
import { stingColors } from '@bbkShared/sting-colors';

export const IndicatorColorsMap = {
  blue: '#394fb7',
  brightPurple: '#9013FE',
  burntYellow: '#FDCB59',
  darkGreen: '#10a069',
  darkPurple: '#452e94',
  darkTeal: '#10A7A7', // dark teal
  gold: '#FBCD57', // gold
  green: '#25CDA8',
  lightBlue: 'lightblue',
  lighterBlue: '#36A2EB', // lighter blue
  lighterPurple: '#9966FF', // light purple
  newPurple: '#b620e0', // light purple
  lightGray: '#C9CBCF', // light gray
  lightGreen: '#20CBA5',
  lightOrange: '#FF7575',
  lightPurple: '#A94ed7',
  lightRed: '#f05150',
  lightTeal: '#4BC0C0', // teal
  limeGreen: '#83D420',
  orange: '#f1a056',
  pink: '#df51C4',
  red: '#F32B43',
  salmon: '#FC6384', // salmon
  teal: '#238eb4',
  white: '#FFFFFF',
  yellow: '#FBCD57',
  yellowOrange: '#f79f45',
  gray: 'rgba(0, 0, 0, 0.1)',
  black30: 'rgba(0, 0, 0, 0.3)',
  deflectRateColor: stingColors.primary['400'],
  saveRateColor: '#4DC0C0',
};

export const BrightbackChartHex = [
  { key: 'salmon', hex: '#FC6384' }, // salmon
  { key: 'gold', hex: '#FDCB59' }, // gold
  { key: 'darkTeal', hex: '#10A7A7' }, // dark teal
  { key: 'lighterBlue', hex: '#36A2EB' }, // lighter blue
  { key: 'lightTeal', hex: '#1fc9a3' }, // light teal
  { key: 'brightPurple', hex: stingColors.primary['400'] }, // bright purple
  { key: 'pink', hex: '#DF51C4' }, // pink
  { key: 'red', hex: '#f52e46' }, // salmon
  { key: 'teal', hex: '#238EB4' }, // teal
  { key: 'orange', hex: '#F1A056' }, // orange
  { key: 'lighterPurple', hex: stingColors.primary['400'] }, // lighter purple
  { key: 'lightGray', hex: '#C9CBCF' }, // light gray
  { key: 'deflectRateColor', hex: stingColors.primary['400'] }, // deflect rate color
  { key: 'saveRateColor', hex: '#4DC0C0' }, // save rate color
] as const;

export const BrightbackChartHexMap = keyBy(BrightbackChartHex, 'key');
